/**
 * 图片配额实体组件
 */
import { useState, useEffect } from 'react';
import { Modal, Input, Row, Col, message, InputNumber } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '图片配额';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [groupPrefix, setGroupPrefix] = useState('');
    const [totalPcs, setTotalPcs] = useState(100);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setGroupPrefix('');
        setTotalPcs(1000000);
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setGroupPrefix(props.record.group_prefix);
            setTotalPcs(props.record.total_pcs);
        }
    }, [props.record]);

    const ok = () => {
        //  参数校验
        if (groupPrefix === '') {
            message.error('组织前缀不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'quota/images' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'group_prefix': groupPrefix,
                'total_pcs': totalPcs,
                'description': description,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={400}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row style={{ lineHeight: CNF.lineHeight, marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>组织前缀{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={groupPrefix}
                            onChange={(e) => { setGroupPrefix(e.target.value) }}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, lineHeight: CNF.lineHeight }}>
                    <Col span={24}>图片配额{rff}</Col>
                    <Col span={24}>
                        <InputNumber
                            value={totalPcs}
                            onChange={(value) => setTotalPcs(value)}
                            disabled={loading}
                            min={10}
                            max={100000}
                            step={10}
                            style={{ width: '100%' }}
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value?.replace(/\s?|(,*)/g, '')}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity